<div class="modal__full">
    <div class="modal-header">
        <h3 class="modal-title" id="exampleModalLabel">Fale conosco</h3>
        <p>Ficou alguma dúvida? Manda uma mensagem.</p>
        <button type="button" class="close" (click)="bsModalRef.hide()">
          <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.3522 9.01106L17.7442 1.61906C17.8323 1.53081 17.9021 1.42608 17.9497 1.31086C17.9972 1.19563 18.0217 1.07216 18.0215 0.947498C18.0214 0.822836 17.9967 0.699421 17.9488 0.584301C17.901 0.469181 17.831 0.36461 17.7427 0.276559C17.6545 0.188508 17.5497 0.1187 17.4345 0.0711227C17.3193 0.0235451 17.1958 -0.000871119 17.0712 -0.000731829C16.9465 -0.000592539 16.8231 0.0240995 16.708 0.0719345C16.5928 0.11977 16.4883 0.189811 16.4002 0.278059L9.01122 7.66906L1.61922 0.278059C1.44139 0.100231 1.2002 0.000328853 0.948718 0.000328853C0.697232 0.000328853 0.456046 0.100231 0.278218 0.278059C0.100391 0.455887 0.000488281 0.697073 0.000488281 0.948559C0.000488281 1.20005 0.100391 1.44123 0.278218 1.61906L7.66922 9.01106L0.278218 16.3991C0.190167 16.4871 0.120321 16.5916 0.072668 16.7067C0.025015 16.8217 0.000488281 16.945 0.000488281 17.0696C0.000488281 17.1941 0.025015 17.3174 0.072668 17.4324C0.120321 17.5475 0.190167 17.652 0.278218 17.7401C0.36627 17.8281 0.470802 17.898 0.585846 17.9456C0.700891 17.9933 0.824195 18.0178 0.948718 18.0178C1.07324 18.0178 1.19655 17.9933 1.31159 17.9456C1.42664 17.898 1.53117 17.8281 1.61922 17.7401L9.01122 10.3481L16.4002 17.7441C16.4885 17.8323 16.5934 17.9023 16.7087 17.95C16.8241 17.9978 16.9477 18.0223 17.0726 18.0223C17.1974 18.0222 17.321 17.9976 17.4364 17.9498C17.5517 17.9019 17.6565 17.8319 17.7447 17.7436C17.833 17.6552 17.903 17.5504 17.9507 17.4351C17.9984 17.3197 18.023 17.1961 18.0229 17.0712C18.0229 16.9464 17.9982 16.8227 17.9504 16.7074C17.9026 16.5921 17.8325 16.4873 17.7442 16.3991L10.3522 9.01106Z"/>
          </svg>
        </button>
    </div>
    <div class="modal-body">
        <form [formGroup]="form" class="validate-form" (ngSubmit)="sendContact()">
            <div class="form-group">
                <label for="name">Seu nome </label><strong>*</strong>
                <input type="text"
                        class="form-control"
                        id="name"
                        placeholder="ex: Maria dias"
                        formControlName="name"
                        autocomplete="off"
                        [ngClass]="{'invalid' :
                            form.controls.name.invalid &&
                            form.controls.name.touched ||
                            submitted && form.controls.name.invalid}"
                            required>
                <div *ngIf="form.controls.name.invalid && form.controls.name.touched ||
                            submitted && form.controls.name.invalid" class="invalid-text-feedback">
                    <span>Esse campo tem preenchimento obrigatório!</span>
                </div>
            </div>
            <div class="form-group">
                <label for="business">Nome do seu negócio</label><strong>*</strong>
                <input type="text" class="form-control" id="business"
                        placeholder="ex: seu negócio"
                        formControlName="business" autocomplete="off" [ngClass]="{'invalid' :
                        form.controls.business.invalid &&
                        form.controls.business.touched ||
                        submitted && form.controls.business.invalid}"
                        required>
                <div *ngIf="form.controls.business.invalid && form.controls.business.touched ||
                        submitted && form.controls.business.invalid" class="invalid-text-feedback">
                    <span>Esse campo tem preenchimento obrigatório!</span>
                </div>
            </div>
            <div class="form-group">
                <label for="email">E-mail para contato</label><strong>*</strong>
                <input type="email" class="form-control" id="email"
                        placeholder="ex: sualoja@gmail.com"
                    formControlName="email"autocomplete="off"
                    [ngClass]="{'invalid' :
                            form.controls.email.invalid &&
                            form.controls.email.touched ||
                            submitted && form.controls.email.invalid}"
                    required>
                <div class="invalid-text-feedback" *ngIf="form.controls.email.invalid && form.controls.email.touched ||
                submitted && form.controls.email.invalid">
                    <span *ngIf="form.controls.email.errors.required">
                      Esse campo tem preenchimento obrigatório!
                    </span>
                    <span *ngIf="form.controls.email.errors.email">
                        Esse campo tem preenchimento obrigatório!
                    </span>
                </div>
            </div>
            <div class="form-group">
                <label for="message">Sua mensagem</label><strong>*</strong>
                <textarea class="form-control" id="message" rows="3"
                    placeholder="Fale para nós como podemos te ajudar..."
                    formControlName="subject"
                    [ngClass]="{'invalid' :
                            form.controls.subject.invalid &&
                            form.controls.subject.touched ||
                            submitted && form.controls.subject.invalid}"
                    required>
                </textarea>
                <div *ngIf="form.controls.subject.invalid && form.controls.subject.touched ||
                            submitted && form.controls.subject.invalid" class="invalid-text-feedback">
                    <span>Esse campo tem preenchimento obrigatório!</span>
                </div>
            </div>
            <div class="buttons">
                <button type="submit">ENVIAR MENSAGEM</button>
            </div>
        </form>
    </div>
</div>
